<mat-form-field class="background pt-1"
                style="max-width: 150px"
                [matBadge]="badge">
  <input #inputField
         matInput
         type="number"
         (input)="onChange($event)"
         (blur)="touchCallback()"
         [disabled]="disabled">
  <mat-icon matSuffix
            fontSet="fa"
            fontIcon="fa-percent"
            style="margin-top:5px;font-size: 0.9rem"></mat-icon>
</mat-form-field>